import { _ as e } from "../internals/export.js";
import { g as s } from "../internals/global.js";
import { t } from "../internals/task.js";
import { s as r } from "../internals/schedulers-fix.js";
var a = t.set,
  m = s.setImmediate ? r(a, !1) : a;
e({
  global: !0,
  bind: !0,
  enumerable: !0,
  forced: s.setImmediate !== m
}, {
  setImmediate: m
});